export default __webpack_public_path__ + "static/media/bank.d60ba92b.svg";